import React from 'react'
import { Link } from 'react-router-dom'
import bg21 from '../../assets/images/background/bg-21.png'
import bg9 from '../../assets/images/background/bg-9.png'
import { useContent } from '../../services'

const teamImages = {
  'team-1.jpg': require('../../assets/images/resource/team-1.jpg'),
  'team-2.jpg': require('../../assets/images/resource/team-2.jpg'),
  'team-3.jpg': require('../../assets/images/resource/team-3.jpg'),
};

function Teem() {
    const { data: team, loading } = useContent('teamContent');

    if (loading || !team) return null;

    return (
        <>
            <section className="team-section">
                <div className="left-bg"><img src={bg21} alt="" title="" /></div>
                <div className="right-bg"><img src={bg9} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>{team.section.subtitle}</span></div>

                        <div className="pattern-image">
                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>{team.section.title}</h2>
                    </div>
                    <div className="row justify-content-center clearfix">
                        {team.chefs.map((chef, index) => (
                            <div key={chef.id} className="team-block col-lg-4 col-md-6 col-sm-12">
                                <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay={`${index * 300}ms`}>
                                    <div className="image">
                                        <img src={teamImages[chef.image]} alt="" />
                                        <div className="overlay-box">
                                            <div className="overlay-inner">
                                                <ul className="social-box">
                                                    {chef.socials.map((social, si) => (
                                                        <li key={si}><Link to={social.url} className={social.icon}></Link></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <h3><Link to="#">{chef.name}</Link></h3>
                                    <div className="designation">{chef.designation}</div>
                                    <div className="text desc">{chef.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Teem
